import { AppHeading1 } from 'components/shared/AppHeading.styled';
import styled from 'styled-components';
import { fontSize, screen, spacing } from 'theme';

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: ${spacing('xs')};
  justify-content: flex-start;
  margin-bottom: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${spacing('lg')};
  }

  ${AppHeading1} {
    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('xl4')};
      line-height: 1.1;
    }
  }
`;
